export default __webpack_public_path__ + "static/media/perugbc1.ebe8a3ed.jpg";